module.exports = __webpack_public_path__ + "static/media/workbuddy-callout.9016db48.png";